import React from "react";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { ParticipantBuyout } from "../../Interfaces/Buyout";

interface FundraiserBuyoutDownloadProps {
  fundraiserName: string;
  participants: ParticipantBuyout[];
}

const FundraiserBuyoutDownload: React.FC<FundraiserBuyoutDownloadProps> = ({
  fundraiserName,
  participants,
}) => {
  const handleDownloadPDF = () => {
    const pdf = new jsPDF();
    const pageWidth = pdf.internal.pageSize.getWidth();
    const margin = 15;

    pdf.text(
      "Fundraiser Donation Participants " + fundraiserName,
      pageWidth / 2,
      15,
      {
        align: "center",
        maxWidth: pageWidth - margin * 2,
      },
    );
    autoTable(pdf, {
      head: [["Participant", "Division", "Buyout Amount"]],
      body: participants.map((participant) => [
        participant.participant_name,
        `${participant.primary_division} - ${participant.secondary_division}`,
        `$${parseFloat(participant.buyout_amount).toFixed(2)}`,
      ]),
      startY: 25,
      styles: { fontSize: 10 },
      theme: "striped",
    });

    // Ensure we have space for the totals section
    const finalY = (pdf as any).lastAutoTable.finalY + 10 || 50;

    const total = participants.reduce(
      (sum, p) => sum + parseFloat(p.buyout_amount),
      0,
    );
    const amountDue = total - total / 1.1;

    // Adjust box size and positioning
    const boxX = 130; // Right side alignment
    const boxY = finalY; // Position below table
    const boxWidth = 60;
    const boxHeight = 15;

    pdf.setFillColor(240, 240, 240); // Light gray background
    pdf.rect(boxX, boxY, boxWidth, boxHeight, "F"); // Box dimensions

    // Align text inside the box
    pdf.setFontSize(12);
    pdf.setTextColor(0, 0, 0);
    pdf.text(`Total: $${total.toFixed(2)}`, boxX + 5, boxY + 6);
    pdf.text(`Amount Due: $${amountDue.toFixed(2)}`, boxX + 5, boxY + 12);

    pdf.save(`${fundraiserName}_Donation_Details_${Date.now()}.pdf`);
  };

  return (
    <div style={{ textAlign: "center" }}>
      <button
        onClick={handleDownloadPDF}
        style={{
          marginTop: "20px",
          padding: "10px 20px",
          fontSize: "16px",
          cursor: "pointer",
          backgroundColor: "#007bff",
          color: "#fff",
          border: "none",
          borderRadius: "5px",
        }}
      >
        Download Buyout PDF
      </button>
    </div>
  );
};

export default FundraiserBuyoutDownload;
